





















































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    //import EditFreight from './mainlandfreight-edit.vue'
    import CreateFreight from './basecost-setting-add.vue'
    import EditModel from './basecost-setting-edit.vue'
    import Enums from '@/lib/enums'
    import DateUtils from '@/common/js/DateUtils'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    Vue.use(Preview);

    class PageFreightRequest extends PageRequest {
        beginTime?: Date;
        endTime?: Date;
        isEffective?: boolean;
        constructor() {
           
            super();
            this.isEffective = null;
   
        }
    }

    @Component
        ({
            name: "basecostsetting",
            components: { CreateFreight, EditModel }
        })
    export default class Freogjt extends AbpBase {
        whetherStatus = Enums.getEnum(Enums.IsEffectiveStatus, true);
        editModalShow: boolean = false;
        pagerequest: PageFreightRequest = new PageFreightRequest();
        creationTime: Date[] = [];
        //editModalShow: boolean = false;
        createModalShow: boolean = false;

        get list() {
            return this.$store.state.basecostsetting.list;
        };
        get loading() {
            return this.$store.state.basecostsetting.loading;
        }
        async ishandle() {
            this.updateStatus();
        }

        async updateStatus() {
            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            //  var statuName = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == statu })[0].name;

            this.$Modal.confirm({
                title: "修改基本费用信息", content: "确认批量处理数据？", onOk: async () => {
                    var ids = [];
                    for (var i = 0; i < selection.length; i++) {
                        ids.push(selection[i].id);
                    }
                    await this.$store.dispatch({
                        type: 'basecostsetting/updateStatus',
                        data: { ids: ids }
                    });
                    this.getpage();

                }
            });
        }
        create() {
            this.createModalShow = true;
        }
        pageChange(page: number) {
            this.$store.commit('basecostsetting/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('basecostsetting/setPageSize', pagesize);
            this.getpage();
        }

        ShowModel() {
            this.editModalShow = true;
        }

        async getpage() {

            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            //filters
            //if (this.creationTime.length > 0) {
            //    this.pagerequest.beginTime = this.creationTime[0];
            //}
            //if (this.creationTime.length > 1) {
            //    this.pagerequest.endTime = this.creationTime[1];
            //}

            await this.$store.dispatch({
                type: 'basecostsetting/getAll',
                data: this.pagerequest
            })
        }
        get pageSize() {
            return this.$store.state.basecostsetting.pageSize;
        }
        get totalCount() {
            return this.$store.state.basecostsetting.totalCount;
        }
        get currentPage() {
            return this.$store.state.basecostsetting.currentPage;
        }
        columns = [
            {
                type: 'selection',
                width: 50,
                align: 'center',
                fixed: 'left',
            }, {
                title: '仓库',
                key: 'warehouseName',
                width: 150,
                fixed: 'left',
            },
            {
                title: '订单类型',
                width: 140,
                key: 'orderType',
                render: (h: any, params: any) => {
                    return h('span', Enums.WarehouseOrderType.filter(function (item) { return item.value == params.row.orderType })[0].name);
                }
            }, {
                title: '麻布袋单价',
                key: 'sackPrice',
                width: 130,
            }, {
                title: '基础费用',
                key: 'baseCost',
                width: 120,
            }, {
                title: '基础Sku数量',
                key: 'baseSkuNums',
                width: 130,
            }, {
                title: '超过基础Sku数量',
                key: 'exceedBaseSkuNums',
                width: 150,
            },
            {
                title: '超过基础Sku费用',
                key: 'exceedSkuCost',
                width: 150,
            },
            
            {
                title: 'Sku封顶费用',
                key: 'maxSkuCost',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', params.row.maxSkuCost == null ? "没有限制" : params.row.maxSkuCost)
                }
            }, {
                title: '是否有效',
                width: 90,
                key: 'isEffective',
                render: (h: any, params: any) => {
                    return h('span', params.row.isEffective ? this.L('是') : this.L('否'))
                }
            }, {
                title: '开始时间',
                key: 'beginTime',
                width: 160,
                render: (h: any, params: any) => {
                    return h('span', params.row.beginTime ? DateUtils.formatLongDate(new Date(params.row.beginTime)) : '');
                }
            }, {
                title: '结束时间',
                key: 'endTime',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', params.row.endTime ? DateUtils.formatLongDate(new Date(params.row.endTime)) : '');
                }
            },
            {
                title: '操作',
                width: 130,
                fixed: 'right',
                key: 'id',
                render: (h: any, params: any) => {
                    var data = params.row;
                    var _this = this;
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '90px',
                                height: '30px',
                                display: data.isEffective == true ? "inline-block" : "none",
                            },
                            on: {
                                click: () => {

                                    _this.$store.state.basecostsetting.id = data.id;
                                    _this.ShowModel();
                                }
                            }

                        }, "修改结束时间")
                    ]);
                }
            }]
        async created() {
            this.getpage();
        }
    }
